import { Component, OnInit, ViewChild, HostListener, EventEmitter, Output, SimpleChanges, Injectable, ViewContainerRef, Injector } from '@angular/core';
import { StaffService } from 'src/app/services/staff/staff.service';
import { Select2OptionData } from 'ng2-select2';
import { TimeSheetService } from 'src/app/services/time-sheet.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router'
import * as moment from 'moment';
import { months } from '../../_models/staticArray'
import { UserTimeSheetService } from '../../services/user-time-sheet.service'
import { SingleWeekComponent } from '../single-week/single-week.component';
import { LocationStrategy, Location } from '@angular/common';
import { saveAs } from "file-saver";
import { UtilityService } from 'src/app/services/utility.service'


@Component({
  selector: 'app-admin-report-b',
  templateUrl: './admin-report-b.component.html',
  styleUrls: ['./admin-report-b.component.scss'],
  // changeDetection: [UserSingleWeekComponent]
})
// @Injectable({
//   providedIn: UserSingleWeekComponent
// })
export class AdminReportBComponent implements OnInit {
  @Output() staffUser: EventEmitter<any> = new EventEmitter<any>();

  public instToDisplay: Array<Select2OptionData> = [];
  public options: Select2Options;
  value: string[];
  allInstructors: any;
  selectedInstructorId: any;
  selectedDates;
  selectedDatesRange: any;
  totalHours;
  overTimeHours;
  totalCalTime;
  sort: MatSort;
  paginator: MatPaginator;
  dataSource: MatTableDataSource<any>;
  down;
  months = months
  displayedColumns: string[] = ['Date', 'LogIn', 'LunchStart', 'LunchEnd', 'LogOut', 'WorkHours', 'TravelHours', 'Total'];
  timeLogs: any;
  totalMinutes: any;
  display: boolean = true;
  displayMsg: boolean;
  datesArray: any[];
  dataForSingleWeek;
  selectedInstructors;
  weekDatesFromAdmin: any;
  isPrint: any = false;
  hide: boolean = false;
  ranges: any[];
  exportShows: boolean = false;
  selected = { 'start': moment(), 'end': moment() };
  loading = false
  allWeeks: any;
  datesRanges: any = [];
  userId: any;
  isClearBtnShow: boolean = false;
  end: any;
  start: any;
  isCalculation: boolean = false
  user = JSON.parse(localStorage.getItem('userRoles'))
  isDisabled: boolean = false

  // weekSheet
  // timeSheet
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  displayColumns: any[] = ['Day', 'On Duty', 'Off Duty', 'Job type/breaks', 'Communiting Time', 'Duty Length', 'Rest Length', 'Average duty per day', 'Commutative Component', 'Duty timing Component', 'Job Type/Break Component', 'Fatigue Index']
  @Output() print: EventEmitter<any> = new EventEmitter<any>();
  @HostListener('window:beforeprint', ['$event'])
  onBeforePrint(event) {
    this.isPrint = true


    // alert('before print');
    // this.removePaginator();
  }

  @ViewChild(SingleWeekComponent, { static: false }) weekSheet: SingleWeekComponent;
  constructor(
    public router: Router,
    private _staffService: StaffService,
    public _timeSheetService: TimeSheetService,
    public _userTimeSheetService: UserTimeSheetService,
    private route: ActivatedRoute,
    private injector: Injector,
    private locationStrategy: LocationStrategy,
    private _location: Location,
    private _utilityServices: UtilityService,
  ) {
    this.dataSource = new MatTableDataSource<any>();
    // this.injector.get(UserSingleWeekComponent)
  }



  // @ViewChild(SingleWeekComponent, { static: false }) private weekSheet: SingleWeekComponent;

  ngOnInit() {
    // const paginatorIntl = this.paginator._intl;
    // paginatorIntl.nextPageLabel = '';
    // paginatorIntl.previousPageLabel = '';
    this.display = true;
    this.options = {
      multiple: false,
      placeholder: "Choose instructors"
    }
    this.getAllInstructors('test1')
    // this.getCurrentWeekDates()
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("***changes", changes);
    if (changes) {
      this.getAllInstructors('test2')
      // this.getCurrentMonthWeeks()
    }
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  getInstructorProfile() {
    if (this.selectedInstructorId) {
      this.selectedInstructorId = this.selectedInstructors._id;
      console.log('this.datesArray in report b =========>>', this.datesArray)
    }
  }
  async selectStaffUser(event) {
    this.isDisabled = false
    console.log("When user change", event);
    await this.getCurrentWeekDates()
    this.staffUser.emit(event._id)
  }


  updateQueryParams(obj) {

    this.route.queryParams.subscribe(params => {
      console.log("params for admin user", params);
      this._location.replaceState(
        this.router.createUrlTree(
          [this.locationStrategy.path().split('?')[0]], // Get uri
          {
            relativeTo: this.route, queryParams: { currentTab: params.currentTab ? params.currentTab : 0, user: obj }
          }
        ).toString()
      );
    });
  }

  printing(event) {
    console.log("**IS PRINTING**", event);
    if (event.msg == 'printing') {
      this.hide = true;
      this.print.emit({ msg: 'printing' })
    }
    else if (event.msg == 'printing complete') {
      this.print.emit({ msg: 'printing complete' })
      this.hide = false
    }
  }
  datesSelected(event) {
    console.log("event in datesSelected function ----> ", event);

    this.display = false;
    this.isDisabled = false
    this.isClearBtnShow = false
    this.selectedDatesRange = event;
    if (event.startDate != null || event.endDate != null) {
      this.isClearBtnShow = true;
      console.log("***selected", this.selected);
      // this.ranges = [event.startDate, event.endDate]
      // console.log("***datesSelected---", event);
      this.getWeekDates(this.selectedDatesRange)
    }
    if (event.startDate == null && event.endDate == null && this.datesArray) {
      console.log("check how much time it is call");
      this.getCurrentWeekDates()
    }
  }


  rangeClicked(range) {
    console.log("***event", range);
  }
  ngModelChange(event) {
    console.log("***ngModelChange", event);
  }
  getWeekDates(selectedDatesRange) {
    let tempStartDate = selectedDatesRange.startDate
    // this.start = selectedDatesRange.startDate
    // this.end = selectedDatesRange.endDate
    let tempEndDate = selectedDatesRange.endDate
    if (tempStartDate && tempEndDate) {
      // console.log("-----getWeekDates-----", selectedDatesRange);
      let dates = []
      dates.push(tempStartDate.format('MM/DD/YYYY'))
      return new Promise((resolve, reject) => {
        while (tempStartDate.add(1, 'days').diff(tempEndDate) < 0) {
          console.log("In while loop");
          // console.log(tempStartDate.toDate());
          dates.push(tempStartDate.clone().format('MM/DD/YYYY'));
        }
        console.log(" AFTER WHILE **dates", dates);
        this.datesArray = dates;
        this.datesRanges = dates
        this.selected = { 'start': moment(this.datesRanges[0]), 'end': moment(this.datesRanges[this.datesRanges.length - 1]) }
        resolve(this.datesArray)
      }).then((resolvedDatesArray: any) => {
        // this.selected = { 'start': moment(this.datesRanges[0]), 'end': moment(this.datesRanges[this.datesRanges.length - 1]) }
        // this.selected = { start: moment(this.datesRanges[0]), end: moment(this.datesRanges[this.datesRanges.length - 1]) }
        console.log("***UPDATE", this.selected);
        this.weekDatesFromAdmin = resolvedDatesArray;
        // this.getTimeLog(resolvedDatesArray)
      })
    }


  }
  getCurrentWeekDates() {
    // this._timeSheetService.getSystemDate().subscribe(date => {
    //   console.log('system Date', date)

    //   let today = new Date(date.systemDate);
    //   this._timeSheetService.getCurrentWeekDates(today).then((res: any) => {
    //     if (res == undefined) return
    //     else {
    //       this.datesRanges = res.weekDates
    //       this.weekDatesFromAdmin = res.weekDates
    //       console.log("this.datesRange", this.datesRanges);
    //       this.selected = { 'start': moment(this.datesRanges[0]), 'end': moment(this.datesRanges[this.datesRanges.length - 1]) }
    //     }
    //   })
    // })
    console.log("this.selectedInstructors", this.selectedInstructors);
    let obj = {
      _isWeek: true,
      selectedUser: this.selectedInstructors._id
    }
    this._timeSheetService.getRailWeekDates(obj).subscribe((dateList) => {
      console.log("THIS IS THE WEEK DATES", dateList)
      this.datesRanges = dateList[0].dateList
      this.weekDatesFromAdmin = dateList[0].dateList
      console.log("this.datesRange", this.datesRanges);
      this.selected = { 'start': moment(this.datesRanges[0]), 'end': moment(this.datesRanges[this.datesRanges.length - 1]) }
      return this.datesRanges
    }, error => {
      console.log("ERROR", error)
      // this._utilityService.handleSnackBar({ msg: error.msg, button: "Ok" })
    })
  }
  weekDates(arg0: string, weekDates: any) {
    throw new Error('Method not implemented.');
  }
  updateData(logs) {
    // console.log('UPDATING DATA = ', logs)
    this.dataSource = new MatTableDataSource(logs);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  // API
  getAllInstructors(test) {
    this.loading = true
    let getTwoArray = false
    this._staffService.getInstructors(getTwoArray).subscribe(instructorsResponse => {
      this.allInstructors = instructorsResponse.trainers.concat(instructorsResponse.iqa);
      this.allInstructors = this.allInstructors.concat(instructorsResponse.operative)
      console.log("instructorsResponse", instructorsResponse, test, this.allInstructors)
      this.allInstructors = this.allInstructors.filter((x) => !x.isArchive)
      this.route.queryParams.subscribe(params => {
        console.log("params in admin time sheet page", params);
        if (this.allInstructors && this.allInstructors[0]) {
          if (params && params.user) {
            let staff = this.allInstructors.find((x) => x._id === params.user)
            this.selectedInstructorId = staff._id
            this.selectedInstructors = staff
            console.log("Value of staff user", staff);
          } else {
            this.selectedInstructorId = this.allInstructors[0]._id
            this.selectedInstructors = this.allInstructors[0]
          }
          this.staffUser.emit(this.selectedInstructorId)
        }
        this.getCurrentWeekDates();
        // if (params.currentTab) {
        //   this.selectedIndex = params.currentTab
        // } else {
        //   // this.updateQueryParams(0)
        //   this.updateQueryParams({ currentTab: this.selectedIndex, user: this.selectedStaffUser })
        // }
      });

      this.allInstructors.forEach(inst => {
        let temp = {
          id: inst._id,
          text: inst.name
        }
        this.instToDisplay.push(temp)
        // console.log("this.instToDisplay", this.instToDisplay);
      })

      this.loading = false
      // this.dataSource = new MatTableDataSource<any>(instructorsResponse)
    })

  }
  getTimeLog(datesArray) {
    let data = {
      date: datesArray,
      instructorId: this.selectedInstructorId
    }


    console.log('data in get timeLog', data);

    if (data.date && data.instructorId) {
      this._timeSheetService.getSecondReportDetails(data).subscribe((responseLogs) => {
        // console.log("---Got time logs---", responseLogs.response[0]);
        if (responseLogs.response && responseLogs.response.length == 0) {
          this.dataForSingleWeek = 'noData'
          this.displayMsg = true;
          return
        }
        else this.displayMsg = false;
        this.dataForSingleWeek = responseLogs.response[0].logs
        this.timeLogs = responseLogs.response[0].logs
        this.totalHours = responseLogs.response[0].totalWorkingHours
        this.totalMinutes = responseLogs.response[0].totalWorkingMinutes
        if (this.totalMinutes == 60) {
          this.totalHours = this.totalHours + 1
          this.totalMinutes = this.totalMinutes - 60
        }
        else if (this.totalMinutes > 60) {
          this.totalHours = this.totalHours + Math.floor(this.totalMinutes / 60)
          this.totalMinutes = this.totalMinutes % 60
        }
        let tempTotalHours = (this.timeLogs.length) * 12
        this.overTimeHours = this.totalHours <= tempTotalHours ? 0 : (this.totalHours - tempTotalHours + ":" + this.totalMinutes)

        // console.log(' this.overTimeHours====>>>>>>', this.overTimeHours);
        // console.log("---tempTotalHours---", tempTotalHours);
        // console.log("this.totalHours", this.totalHours, "this.totalMinutes", this.totalMinutes);
        this.updateData(this.timeLogs)
        // this.dataSource = new MatTableDataSource<any>(this.timeLogs);
      })
    }
  }


  public fatigueIndexCalculation() {
    console.log("current selected user", this.selectedInstructors);
    this.isDisabled = true
    this._utilityServices.openSnackBar("Performing calculations for fatigue and risk assessment. Please wait...", "Ok")
    const data = {
      userId: this.selectedInstructors.userId._id,
      type: 'fatigue'
    }
    this.isCalculation = false;
    console.log("this is the data to be send", data);
    this.isCalculation = false
    this._userTimeSheetService.getFatigueIndex(JSON.stringify(data)).subscribe((response) => {
      console.log("response of fatigue index", response);
      this.isCalculation = true;
      this.isDisabled = false;
      this._utilityServices.openSnackBar("The fatigue and risk calculation has been completed.", "Ok")
    }, err => {
      console.log("error while get fatigue index", err);
      this.isDisabled = false;
    })
  }

  printsingleWeekReport(format) {
    // this.injector.get(UserSingleWeekComponent).printsingleWeekReport()
    this._userTimeSheetService.generateReport('adminSheet', format)
  }

  printExpenseReport() {
    this.loading = true
    this._utilityServices.openSnackBar("Download will begin automatically", "Ok")
    console.log("DATE RANGE SELECTED", this.datesRanges)
    console.log("SELECTED USER", this.selectedInstructors)
    let obj = {
      dateRange: this.datesRanges,
      userId: this.selectedInstructors.userId._id
    }
    this._userTimeSheetService.generateExpenseReport(obj).subscribe((response) => {
      console.log("THISIS THE RESPONSE OF GENERATE REPORT ", response);
      const byteArray = new Uint8Array(response.bufferData.data);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      saveAs(blob, 'expense-report');
      this._utilityServices.openSnackBar("Expense Report Download Successfully", "Ok")
      this.loading = false
    }, error => {
      this.loading = false
      this._utilityServices.openSnackBar("Error while download expense report", "Ok")
    })
  }


}
